import axios from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import SimpleSTLViewerToImage from "../Canvas/SimpleStlViewsImage";
import config from '../../config';
import { headers } from "../../token";
import QRCode from "react-qr-code";
import React from "react";
import ReactDOM from "react-dom";
import validateError from "../../ValidateError";
import Swal from "sweetalert2";
import vAdminformat from "../../adminFormat";

const server_backend = config.API_URL;

const generateQRCodeImage = async (value) => {
    return new Promise((resolve) => {
        // Create a container to render the QR code
        const qrContainer = document.createElement('div');
        qrContainer.style.position = 'absolute';
        qrContainer.style.top = '0';
        qrContainer.style.left = '0';
        qrContainer.style.width = '100px';
        qrContainer.style.height = '100px';
        qrContainer.style.overflow = 'hidden';
        document.body.appendChild(qrContainer);

        // Render the QR code component into the container
        ReactDOM.render(<QRCode value={value} size={100} />, qrContainer);

        // Wait for the QR code to be rendered and then capture it
        setTimeout(async () => {
            const canvas = await html2canvas(qrContainer);
            const imgData = canvas.toDataURL('image/png');
            document.body.removeChild(qrContainer); // Clean up the container
            resolve(imgData);
        }, 1000); // Increase timeout to ensure rendering
    });
};

const downloadJobPDF = async (jobID) => {
    try {
        // Fetch job details
        const response = await axios.get(`${server_backend}/jobs/manual/select?id=${jobID}`, headers);
        const data = response.data.RES_RESULT;

        if (response.data.RES_CODE === "00") {
            const fileURL = `${server_backend}/${data.files_path_file}`;
            console.log("Unexpected error, please check")
            // Load STL image
            const imageURL = await SimpleSTLViewerToImage(fileURL);

            // Generate QR codes
            const qrCodeImageURL = await generateQRCodeImage(data.barcode);

            // Generate PDF
            setTimeout(async () => {
                const input = document.createElement('div');
                input.id = 'printable-area';
                input.style.width = '700px';
                input.style.padding = '20px';

                // Create the content to render into PDF
                input.innerHTML = `
                    <div class="container mt-4 p-4" style="width: 500px; padding: 20px;">
                        <div class="row">
                            <div class="col-12 mb-4">
                                <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
                                    <tbody>
                                        <tr>
                                            <td style="padding: 4px 8px;"><strong>Name:</strong></td>
                                            <td style="padding: 4px 8px;">${data.customer_name || "Customer Name"}</td>
                                        </tr>
                                        <tr>
                                            <td style="padding: 4px 8px;"><strong>Job Number:</strong></td>
                                            <td style="padding: 4px 8px;">${data.job_number || "Job Number"}</td>
                                        </tr>
                                        <tr>
                                            <td style="padding: 4px 8px;"><strong>Date:</strong></td>
                                            <td style="padding: 4px 8px;">${vAdminformat.FormatDate(data.date_created) || "Date Created"}</td>
                                        </tr>
                                        <tr>
                                            <td style="padding: 4px 8px;"><strong>Description:</strong></td>
                                            <td style="padding: 4px 8px;">${data.description || "Description"}</td>
                                        </tr>
                                        <tr>
                                            <td style="padding: 4px 8px;"><strong>Parts:</strong></td>
                                            <td style="padding: 4px 8px;">${data.parts || "Parts"}</td>
                                        </tr>
                                        <tr>
                                            <td style="padding: 4px 8px;"><strong>Alloy:</strong></td>
                                            <td style="padding: 4px 8px;">${data.materials_name || "Material"}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="col-12">
                                <div class="row">
                                    <div class="col-6">
                                        <div class="text-center">
                                            ${imageURL ? `<img src="${imageURL}" alt="STL Image" style="width: 100%; height: 33vh; min-width: 16vh; border: 1px solid #ccc;" />` : '<p>Loading Image...</p>'}
                                        </div>
                                    </div>
                                    <div class="col-6" style="padding-left: 10px;">
                                        <div class="row">
                                            <div class="col-6 text-center">
                                                ${qrCodeImageURL ? `<img src="${qrCodeImageURL}" alt="QR Code" style="margin-bottom: 10px;" />` : '<p>Loading QR Code...</p>'}
                                            </div>
                                            <div class="col-6 text-center">
                                                <h6 style="font-size: 12px; margin-top: 40px;">Collective QR</h6>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6 text-center">
                                                ${qrCodeImageURL ? `<img src="${qrCodeImageURL}" alt="QR Code" style="margin-bottom: 10px;" />` : '<p>Loading QR Code...</p>'}
                                            </div>
                                            <div class="col-6 text-center">
                                                <h6 style="font-size: 12px; margin-top: 40px;">Single QR</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                `;

                document.body.appendChild(input); // Append temporarily to render

                const canvas = await html2canvas(input, { scale: 2, backgroundColor: null });
                const imgData = canvas.toDataURL('image/jpg');
                const pdf = new jsPDF('p', 'mm', 'a4');

                const pdfWidth = 210;
                const pdfHeight = 297;
                const margin = 0;
                const imgWidth = canvas.width / 2;
                const imgHeight = canvas.height / 2;
                const scaleFactor = Math.min((pdfWidth - margin * 2) / imgWidth, (pdfHeight - margin * 2) / imgHeight);
                const finalWidth = imgWidth * scaleFactor;
                const finalHeight = imgHeight * scaleFactor;
                const xOffset = (pdfWidth - finalWidth) / 2;
                const yOffset = (pdfHeight - finalHeight) / 2;

                pdf.addImage(imgData, 'JPG', xOffset, yOffset, finalWidth, finalHeight);
                pdf.save(`${data.job_number + " | " + vAdminformat.FormatDate(data.date_created)}.pdf`);

                document.body.removeChild(input); // Clean up the temporary div
            }, 1000); // Increased timeout to ensure QR Code is loaded

        } else {
            Swal.fire({
                icon: 'error', // Shows an error icon
                title: 'Oops...',
                text: 'An unexpected error has occurred while downloading the file. If the issue persists, please contact the administrator.',
            });
        }
    } catch (error) {
        validateError(error)
    }
};

export default downloadJobPDF;
